import { buildHead } from "@/lib/seo";
import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/select-plan")({
  head: () =>
    buildHead({
      title: "Choose Your Plan | LohaLink",
      description: "Pick a LohaLink seller subscription plan.",
      canonical: "/select-plan",
      noindex: true,
    }),
  component: lazyRouteComponent(() => import("@/pages/SelectPlan")),
});
